
export type CertifikatState = "INITIAL" | "TYPE_SELECTED" | "CERTIFIKAT_SELECTED";

export type VKCertifikatDTO = {
    id: number;
    certifikatsnummer: string;
    certifikatstyp: string;
    agare: string;
    aktiv: boolean;
    sveaskog: boolean;
    giltigTom?: Date;
};

export type KontraktCertifikatDTO = {
    certifikatstyp?: string;
    id?: number;
    kontrolldatum?: string;
    certifikatsnummer?: string;
    certifikatTomDatum?: Date;
    selected: boolean;
};

export type KontraktCertifikatEditDTO = {
    certifikatId: number;
    kontrolldatum: string;
    selected: boolean;
    certifikatstyp: string;
    certifikatsnummer: string;
    certifikatTomDatum?: Date;
};

export class KontraktCertifikat {
    selected = false;
    certifikatId: number | null = null;
    kontrolldatum: string | null = null;
    certifikatstyp: string;

    get state(): CertifikatState {
        if(this.certifikatId) {
            return "CERTIFIKAT_SELECTED";
        } else if(this.selected) {
            return "TYPE_SELECTED";
        } else {
            return "INITIAL";
        }
    }
}
